import dynamic from 'next/dynamic';
import Title from "@/components/Title";

const CounterSection = dynamic(() => import('@/components/Home2/CounterSection'));
const PartnerLogo = dynamic(() => import('@/components/Home2/PartnerLogo'));

// Rich Text helper for Strapi Blocks
const renderRichText = (blocks) => {
  if (typeof blocks === 'string') return blocks;
  if (Array.isArray(blocks)) {
    return blocks.map(block => {
      if (block.type === 'paragraph') {
        return block.children.map(child => child.text).join('');
      }
      return '';
    }).join('\n');
  }
  return '';
};

const PartnershipSection = ({ data, partnerLogosData, loading }) => {
  return (
    <section
      className="w-full h-full mx-auto bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/our-partner.svg')" }}
    >
      <div className='inner_top_bottom_space'>
        <div className='max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]'>
          <div className="w-full heading_space_bottom">
            <Title
              heading={data?.Title || "Our Partnership Ecosystem"}
              subText={renderRichText(data?.Description) || "Cultivating strategic partnerships across industries and governments, we connect exceptional learning with high-impact opportunities."}
              color="text-white"
              subTextColor="text-white/70"
              align="text-left"
            />
          </div>
          <CounterSection data={data} loading={loading} />
          <h2 className='font-bold text-[24px] md:text-[30px] lg:text-[36px] text-left text-white mt-8'>
            {partnerLogosData?.Title || "Industry Partners Recruiting Our Graduates"}
          </h2>
        </div>
        <div className='w-full relative'>
          <PartnerLogo data={partnerLogosData} loading={loading} />
        </div>
      </div>
    </section>
  );
};

export default PartnershipSection;
